// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O7wb","textarea":"styles_textarea__TFUga"};